module.exports = __webpack_public_path__ + "img/download.5be9dd52.svg";